import { FC } from 'react'
import { AuthService } from '../../interactors/services/AuthService'
import { DashboardStructure } from '../DashboardStructure'
import { ProductsDashboard } from '../Shopping/ProductsDashboard'

export const DashboardDisplay: FC = () => {
  return AuthService.isLogged() ? <DashboardStructure /> : <ProductsDashboard />
}
